import React from 'react';

export default React.forwardRef(
  ( {
    indeterminate, rowId, onRowSelect, ...rest
  }, ref ) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect( () => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate] );

    return (
      <div className="custom-control custom-checkbox custom-checkbox-white">
        <input
          className="custom-control-input"
          type="checkbox"
          id={rowId}
          ref={resolvedRef}
          {...rest}
        />
        <label
          htmlFor={rowId}
          className="custom-control-label"
        />
      </div>
    );
  },
);
